import React from 'react';
import { ErrorBoundary } from '@fiverr-private/ui_utils';
import { Stack } from '@fiverr-private/layout_components';
import { logger } from '@fiverr-private/obs';
import { useSellerRole } from '../../hooks/useSellerRole';
import { FAQTitle } from './FAQTitle';
import { FAQContent } from './FAQContent';

interface FAQSectionProps {
    sellerRoleId?: string;
}

export const FAQSection: React.FC<FAQSectionProps> = ({ sellerRoleId }) => (
    <ErrorBoundary onError={onRenderError}>
        <FAQSectionInner sellerRoleId={sellerRoleId} />
    </ErrorBoundary>
);

const FAQSectionInner: React.FC<FAQSectionProps> = ({ sellerRoleId }) => {
    const sellerRole = useSellerRole(sellerRoleId);
    if (!sellerRole) {
        return null;
    }

    const { faq } = sellerRole;
    if (!faq.length) {
        return null;
    }

    return (
        <>
            <Stack direction="column" gap="4">
                <FAQTitle />
                <FAQContent items={faq} />
            </Stack>
        </>
    );
};

const onRenderError = (originalError) => {
    const err = new Error('Failed while rendering the "FAQSection" Component');
    logger.error(err, { cause: originalError });
};
